// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3chIS","label":"Category_label__1BGl5","content":"Category_content__29jfk","header":"Category_header__18def","location":"Category_location__3YT2B"};